import { useState } from "react";
import { router } from "@inertiajs/react";
import {
  EnvelopeIcon,
  ArrowTopRightOnSquareIcon,
  ArrowPathIcon,
} from "@heroicons/react/24/outline";

interface ConfirmationShowProps {
  email: string;
  flash?: { notice?: string; alert?: string };
}

export default function ConfirmationShow({ email }: ConfirmationShowProps) {
  const [resending, setResending] = useState(false);

  const handleResend = () => {
    setResending(true);
    router.post("/admin/confirm_email/resend", {}, {
      onFinish: () => setResending(false),
    });
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <div className="bg-card rounded-lg border border-border shadow-sm p-8">
          <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6">
            <EnvelopeIcon className="w-8 h-8 text-primary" />
          </div>

          <h1 className="text-2xl font-bold text-foreground mb-2">
            Check your email
          </h1>

          <p className="text-muted-foreground mb-6">
            We sent a confirmation link to{" "}
            <strong className="text-foreground">{email}</strong>. Open the email
            and click the link to access the admin portal.
          </p>

          <div className="flex flex-col gap-3">
            <button
              onClick={() => window.open("https://mail.google.com", "_blank")}
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
            >
              <ArrowTopRightOnSquareIcon className="w-4 h-4" />
              Open Gmail
            </button>

            <button
              onClick={handleResend}
              disabled={resending}
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 border border-border rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors disabled:opacity-50"
            >
              <ArrowPathIcon className="w-4 h-4" />
              {resending ? "Sending..." : "Resend confirmation email"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
